import { createMediaButton } from "../create-media-button.js";
import { MuteButtonCore, MuteButtonDataAttrs } from "@videojs/core";
import { selectVolume } from "@videojs/core/dom";
//#region src/ui/mute-button/component.tsx
/** A button that toggles mute state. */
const MuteButton = createMediaButton({
	displayName: "MuteButton",
	core: MuteButtonCore,
	stateAttrMap: MuteButtonDataAttrs,
	selector: selectVolume,
	action: (core, state) => core.toggle(state),
	hotkeyAction: "toggleMuted",
	isSupported: (state) => !state.hidden
});
//#endregion
export { MuteButton };

//# sourceMappingURL=component.js.map